
import React from 'react';
import { WHATSAPP_URL } from '../constants';

const Navbar: React.FC = () => {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <div className="flex items-center">
          <a 
            href="#inicio" 
            onClick={(e) => scrollToSection(e, 'inicio')}
            className="flex items-center group"
          >
            <span className="text-2xl font-bold tracking-tighter text-slate-900">
              DECO<span className="text-slate-500 font-light group-hover:text-slate-700 transition-colors">MAST</span>
            </span>
          </a>
        </div>
        
        <div className="hidden md:flex space-x-8">
          <a href="#inicio" onClick={(e) => scrollToSection(e, 'inicio')} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Inicio</a>
          <a href="#caracteristicas" onClick={(e) => scrollToSection(e, 'caracteristicas')} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Características</a>
          <a href="#galeria" onClick={(e) => scrollToSection(e, 'galeria')} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Galería</a>
          <a href="#nosotros" onClick={(e) => scrollToSection(e, 'nosotros')} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Nosotros</a>
        </div>

        <div className="flex items-center">
          <a 
            href="#faq" 
            onClick={(e) => scrollToSection(e, 'faq')}
            className="hidden sm:inline-block text-sm font-medium text-slate-600 hover:text-slate-900 mr-6"
          >
            Preguntas
          </a>
          <a 
            href={WHATSAPP_URL} 
            target="_blank"
            rel="noopener noreferrer"
            className="bg-slate-900 text-white px-5 py-2.5 rounded text-sm font-semibold hover:bg-slate-800 transition-all shadow-md active:scale-95"
          >
            Pedir Oferta
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
